import Api from '@/api/Api'

class PaymentFee extends Api {
  protected resource = 'payment-fee'

  public async calculate<T>(request: PaymentFeeRequest) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}`)
      .post(request)
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new PaymentFee()
